import { redirect, type LoaderFunctionArgs } from "react-router-dom";
import { authControllerMeV1Options } from "@/client/@tanstack/react-query.gen";
import { route, RouteKeys } from "@/services/routing/routes";
import queryClient from "@/services/react-query/query-client";

export function guestLoader() {
  return async (args: LoaderFunctionArgs) => {
    try {
      // Use queryClient.fetchQuery so the result is cached for 5 minutes (global staleTime).
      // Visiting sign-in/sign-up/forgot-password in quick succession shares the cached response.
      const user = await queryClient.fetchQuery(authControllerMeV1Options());

      if (user) {
        const searchParams = new URL(args.request.url).searchParams;
        const returnTo = searchParams.get("returnTo") || route(RouteKeys.HOME);
        return redirect(returnTo);
      }

      return null;
    } catch {
      return null;
    }
  };
}
